import React, { useEffect } from 'react';
import { RemoveBonusConfirm } from '@it25syv/25syv-ui';
import { hideModal } from './../actions/UiActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { resetBonus } from '../actions/BonusActions';
import { NotificationManager } from 'react-notifications';
import BonusService from '../utils/BonusService';

const RemoveBonusConfirmModal = ({ bonus, HideModal, ResetBonus }) => {
    const { amount } = bonus;

    const removeBonus = () => {
        BonusService.feitBonuses().then((res) => {
            if (res && res.success) {
                ResetBonus();
                HideModal('REMOVE_BONUS_CONFIRM_MODAL');
                //NotificationManager.success('Din bonus er nu fjernet.');
            } else {
                NotificationManager.error('Something went wrong');
                HideModal('REMOVE_BONUS_CONFIRM_MODAL');
            }
        });
    };

    return (
        <div className={'ui-modal-wrapper'}>
            {Object.keys(bonus).length > 0 && (
                <RemoveBonusConfirm
                    bonusAmount={amount.toString()}
                    onConfirm={removeBonus}
                    onCancel={() => {
                        HideModal('REMOVE_BONUS_CONFIRM_MODAL');
                    }}
                />
            )}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        bonus: state.bonus,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        HideModal: bindActionCreators(hideModal, dispatch),
        ResetBonus: bindActionCreators(resetBonus, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RemoveBonusConfirmModal);
